﻿import { Component, ViewChild, Input, OnInit } from "@angular/core";
import { ChartComponent } from "ng-apexcharts";
import { PieChartModel } from "./..//../models/analytics.model";

import {
    ApexNonAxisChartSeries,
    ApexResponsive,
    ApexChart
} from "ng-apexcharts";

export type ChartOptions = {
    series: ApexNonAxisChartSeries;
    chart: ApexChart;
    responsive: ApexResponsive[];
    labels: any;
};

@Component({
    selector: "donut-chart",
    templateUrl: "./donut-chart.component.html"
})
export class DonutChartComponent implements OnInit {
    @ViewChild("donutchart") chart: ChartComponent;
    @Input("data") data: PieChartModel = new PieChartModel();
    public chartOptions: Partial<ChartOptions>;

    constructor() {
        
    }

    ngOnInit() {
        this.chartOptions = {
            series: this.data.series,
            chart: {
                type: "donut"
            },
            labels: this.data.labels,
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: "bottom"
                        }
                    }
                }
            ]
        };
    }
}